import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { TOwnerNode, TOwnershipStructure } from '../types';
import { Box, Typography } from '@mui/material';
import { OwnerCardView } from './OwnerCard/OwnerCardView';
import { commonStyles } from '~/theme/styles/commonStyles';

export const BeneficiaryOwnerList = React.memo(() => {
  const { control } = useFormContext<TOwnershipStructure>();
  const owners = useWatch({ control, name: 'owners' });
  const beneficiaryOwners = owners.filter((owner) => owner.isBeneficiary);

  return (
    <>
      <Typography variant="h5" sx={{ textAlign: 'center' }}>
        Перелік фізичних осіб, які визначені кінцевими бенефіціарними власниками (КБВ)
      </Typography>
      {beneficiaryOwners.length ? (
        <Box sx={{ ...commonStyles.columnFlexContainer, gap: 1, mt: 2 }}>
          {beneficiaryOwners.map((owner) => (
            <OwnerCardView owner={owner as TOwnerNode} key={owner.id} />
          ))}
        </Box>
      ) : (
        <Box sx={{ p: 3 }}>
          <Typography sx={{ textAlign: 'center', color: 'grey' }}>
            КБВ не визначені. Позначте фізичну особу як КБВ у розділі «Відомості про структуру
            власності»
          </Typography>
        </Box>
      )}
    </>
  );
});
